import React from 'react';

import Modal from '../../Components/Modal';

const Emi = ({ active, toogleEmiModal }) => {
  return (
    <Modal active={active}>
      <div className="emi-container">
        <button onClick={toogleEmiModal} className="emi-close-box">
          <i className="fas fa-times"></i>
        </button>
        <h2>Emi Details</h2>
        <p>-------</p>
      </div>
    </Modal>
  );
};

export default Emi;



// WEBPACK FOOTER //
// ./src/Pages/LiveClass/Emi.js